export default __webpack_public_path__ + "static/media/slider-3.3e2032dc.jpg";